module.exports = require('./promise')



//////////////////
// WEBPACK FOOTER
// ./~/universal-promise/index.js
// module id = 588
// module chunks = 0